import React from 'react';
import './PuzzleShell.css';

const GRID_SIZE = 7;

const MESSAGES = {
  not_yet_published: {
    title: "That puzzle isn't out yet",
    detail: 'Come back when the day arrives.',
    canRetry: false,
  },
  not_found: {
    title: 'No puzzle for that date',
    detail: 'The archive starts on 27 May 2026.',
    canRetry: false,
  },
  network: {
    title: "Couldn't reach the server",
    detail: 'Check your connection and try again.',
    canRetry: true,
  },
  version: {
    title: 'This page is out of date',
    detail: 'Reload to pick up the latest version.',
    canRetry: true,
  },
};

const FALLBACK = {
  title: "Couldn't load the puzzle",
  detail: 'Something went wrong on our end.',
  canRetry: true,
};

/**
 * Placeholder shown while the snapshot loads, and the error state if it fails.
 *
 * The skeleton is a full-size 7x7 grid rather than a spinner: .flip-card is
 * height-constrained and the board collapsing then expanding is a visible jump.
 *
 * There is deliberately no fall back to client-side generation — that would
 * mean keeping the 388KB word list in the bundle, which is most of the point of
 * serving snapshots.
 */
const PuzzleShell = ({ status, error, onRetry }) => {
  if (status === 'error') {
    const { title, detail, canRetry } = MESSAGES[error?.kind] || FALLBACK;

    return (
      <div className="puzzle-shell puzzle-shell-error">
        <p className="puzzle-shell-title">{title}</p>
        <p className="puzzle-shell-detail">{detail}</p>
        {canRetry && (
          <button type="button" className="puzzle-shell-retry" onClick={onRetry}>
            Try again
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="puzzle-shell" aria-busy="true" aria-label="Loading today's puzzle">
      <div className="puzzle-shell-grid">
        {Array.from({ length: GRID_SIZE * GRID_SIZE }).map((_, i) => (
          <div key={i} className="puzzle-shell-cell" />
        ))}
      </div>
    </div>
  );
};

export default PuzzleShell;
